import api from './client';

export const authApi = {
  login: (payload) => api.post('/auth/login', payload),
  register: (payload) => api.post('/auth/register', payload),
  me: () => api.get('/auth/me'),
  logout: () => api.post('/auth/logout'),
  changePassword: (payload) => api.post('/auth/change-password', payload),
  forceLogout: (userId) => api.post(`/users/${userId}/force-logout`),
  impersonate: (userId) => api.post(`/users/${userId}/impersonate`),
  stopImpersonation: (impersonatorId) => api.post('/auth/stop-impersonation', { impersonator_id: impersonatorId }),
};
